import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "demo-api-key",
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-project"}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-project",
  storageBucket: "vendviitor-web.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "demo-app-id"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
// Default storage for Downloads page (monthly reports)
export const storage = getStorage(app);

// App Check is disabled for all environments
// TODO: Re-enable App Check later when reCAPTCHA configuration is ready
console.log('App Check disabled - will be configured later');

// Emulator connections disabled - using production Firebase for stability
// TODO: Re-enable emulators when properly configured
// if (import.meta.env.DEV) {
//   try {
//     connectAuthEmulator(auth, "http://localhost:9099");
//     console.log("Connected to Auth emulator");
//   } catch (error) {
//     console.log("Auth emulator connection failed:", error.message);
//   }

//   try {
//     connectFirestoreEmulator(db, 'localhost', 8080);
//     console.log("Connected to Firestore emulator");
//   } catch (error) {
//     console.log("Firestore emulator connection failed:", error.message);
//   }
// }

export default app;
